import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { IconButton } from "../custom_components/customButton";
import { deleteDistrict, fetchDistricts } from "../stores/api_calls/locations";
import { RiDeleteBin2Fill, RiEdit2Fill } from "react-icons/ri";
import "./locations.scss";
import { DistrictEditForm } from "../forms/locations/DistrictForm";
import CustomDeleteModal from "../custom_components/customDeleteModal";
import { error, success } from "../contants/snackbars";

const Districts = (props) => {
    const { itemId, districts, getDistricts } = props;
    const [showModal, setShowModal] = useState({
        showEditForm: false,
        showDelete: false,
        data: {},
        type: "District",
    });

    useEffect(() => {
        if (itemId) {
            getDistricts();
        }
    }, [itemId]);

    const handleEditDistrict = (record) => {
        setShowModal({ ...showModal, showEditForm: true, data: record });
    };

    const handleDeleteDistrict = (record) => {
        setShowModal({ ...showModal, showDelete: true, data: record });
    };

    const onDeleteDistrictSubmit = () => {
        const removeDistrict = deleteDistrict(showModal.data._id);
        removeDistrict
            .then((res) => {
                if (res.data.success) {
                    getDistricts();
                    success("District Deleted Successfully");
                    setShowModal({ ...showModal, showDelete: false, data: {} });
                }
            })
            .catch((e) => {
                error(
                    `Opps! ${e.response?.data?.server_response || "Error"} . Fetched Failed. Please try again later`,
                );
            });
    };

    return (
        <div className="models-container">
            {districts.isLoading ? (
                <p>Fetching Lists...</p>
            ) : !districts.isLoading && districts.data.length ? (
                <div>
                    <Row gutter={[15, 15]}>
                        {districts.data.map((district, index) => (
                            <Col key={index} span={districts.length > 3 ? 6 : 8}>
                                <div className="model-container">
                                    <p>{district.name}</p>
                                    <div className="actions-icons-container">
                                        <IconButton
                                            className="icon-button edit"
                                            tootTipTitle="Edit District"
                                            Icon={<RiEdit2Fill />}
                                            onClick={() => handleEditDistrict(district)}
                                        />
                                        <IconButton
                                            className="icon-button delete"
                                            tootTipTitle="Delete District"
                                            Icon={<RiDeleteBin2Fill />}
                                            onClick={() => handleDeleteDistrict(district)}
                                        />
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </div>
            ) : (
                <p>No Districts Found</p>
            )}

            <DistrictEditForm
                getDistricts={getDistricts}
                visible={showModal.showEditForm}
                onCancel={() => {
                    setShowModal({ ...showModal, showEditForm: false, data: {} });
                }}
                data={showModal.data}
            />

            <CustomDeleteModal
                title={`Delete ${showModal.type}`}
                visible={showModal.showDelete}
                onSubmit={onDeleteDistrictSubmit}
                onCancel={() =>
                    setShowModal({ ...showModal, showDelete: false, data: {} })
                }
                data={{ itemName: `${showModal.data.name}`, type: showModal.type }}
            />
        </div>
    );
};

export default Districts;
